<div class="av-date-range d-flex flex-column">
  <span class="av-date-range__label">{{ label() | translate }}</span>
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="av-date-range__field">
    <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate">
      <input
        matStartDate
        [formControl]="fromControl"
        [placeholder]="'app.reports.allDemands.filters.dateFrom' | translate"
        [attr.aria-label]="label() | translate"
        (dateChange)="onDateInputChange(picker.opened)"
      />
      <input
        matEndDate
        [formControl]="toControl"
        [placeholder]="'app.reports.allDemands.filters.dateTo' | translate"
        [attr.aria-label]="label() | translate"
        (dateChange)="onDateInputChange(picker.opened)"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker
      #picker
      [panelClass]="showPresets() ? presetsPanelClass : ''"
      (closed)="commitRange()"
    >
      @if (showPresets()) {
        <mat-date-range-picker-actions>
          <div
            class="av-date-presets"
            role="group"
            [attr.aria-label]="'app.reports.allDemands.filters.presets.label' | translate"
          >
            @for (option of presetOptions; track option.id) {
              <button
                type="button"
                class="av-date-presets__item"
                [class.is-active]="activePresetId() === option.id"
                [attr.aria-pressed]="activePresetId() === option.id"
                (click)="applyPreset(option, picker)"
              >
                <mat-icon class="av-date-presets__check" aria-hidden="true">check</mat-icon>
                <span>{{ option.labelKey | translate }}</span>
              </button>
            }
          </div>
          <div class="av-date-presets__footer">
            <button type="button" mat-button matDatepickerCancel>
              {{ 'shared.general.buttons.cancel' | translate }}
            </button>
            <button type="button" mat-flat-button color="primary" matDatepickerApply>
              {{ 'shared.general.buttons.apply' | translate }}
            </button>
          </div>
        </mat-date-range-picker-actions>
      }
    </mat-date-range-picker>
  </mat-form-field>
  @if (inverted()) {
    <p class="av-date-range__error m-0" role="alert">
      {{ 'app.reports.allDemands.filters.dateRangeInvalid' | translate }}
    </p>
  }
</div>
